import pic_01 from './Assets/pic_01.webp';
import pic_02 from './Assets/pic_02.webp';
import pic_03 from './Assets/pic_03.webp';
import pic_04 from './Assets/pic_04.webp';
import pic_05 from './Assets/pic_05.webp';
import marionBalinoff from './Assets/Marion-Balinoff.webp';

export const ambassador = {
  name: 'Marion Balinoff',
  position: 'left',
  description: <>
    <p>
      With a decade in influencer marketing - six years focused on mobile gaming - Marion Balinoff helps companies turn influencer marketing into a high-performing acquisition channel. She started agency-side, running campaigns across industries, before shifting in-house to shape strategy and drive measurable impact. From working with top-tier creators to building influencer programs from scratch, she's tackled everything from casual games to niche audiences. Now, as a consultant, she helps mobile gaming companies crack the code on scaling influencer marketing profitably.
    </p>
  </>,
  image: marionBalinoff,
  socialLinks: {
    linkedin: 'https://www.linkedin.com/in/marion-balinoff/',
  },
};

export const EpochInfo = {
  title: 'WORDPRESSISM',
  period: '1998 - 2004',
  description: <>
    <p>
      Welcome to WordPressism, a remarkable era in blogging history. In this era, speech is free, and self-expression is limitless. Everyone, from stay-at-home parents to journalists, has been able to raise their voices to the world.
    </p>
    <p>
      During this time, with the phenomenal growth of the internet and user-friendly blog applications, two main categories of blogs gradually emerged: personal blogs, which served as multi-topic diaries, and professional ones, which focused on more specific subjects. This gave birth to powerful digital personas that seemed to pop up everywhere in posts and blogrolls, shaping the digital landscape.
    </p>
    <p>
      By the end of 2000, thousands of blossoming blogs offered niche insights, alternative viewpoints, and creative expression. WordPressism is a vibrant explosion of digital creativity and individuality.
    </p>
  </>,
};

export const events = [
  {
    year: '1998',
    title: 'Open Diary. Open up opportunities',
    content: (
      <>
        <p>
          The launch of Open Diary on October 20, 1998, marked a turning point, not just for blogging but for self-expression as a whole. This platform empowered everyday individuals, even those with no programming skills, to have a voice online, laying the foundation for what would soon become WordPressism — a movement that celebrated the freedom of digital speech.
        </p>
      </>
    ),
    img: pic_01,
    blurhash: '|68p[b9F0g~AIpJD#ktREL4.S$s:%2%1IUbb$*ofD+-oob9axas-Nxnis.IpaxxaIVWY%KniI:bHocRl$%xZIqjFt5NHjYxuV@j[t7IVt7t5RlWCRkaxS4jcxsS4Rj%0R+jYozM{M{xuRkWYxYofWSafjvx[soIUNws.oe',
    picName: 'pic_01',
  },
  {
    year: '1999',
    title: 'The Big Three is Born',
    content: (
      <>
        <p>
          The Big Three — Xanga, LiveJournal, and Blogger — were the largest blogging platforms that offered complete freedom in the blogging format. Xanga became a prototype for MySpace and was one of the first services to make users fall in love with "likes," empowering them to show their approval for a publication.
        </p>
      </>
    ),
    img: pic_02,
    blurhash: '|FD8%p9t5W=|V@~BEMSi^PsmNHRj-UIps.oeE2xGoMIot6s:I:WBjZWVWVNHxZxYofNHoJs:WVofRks:s.WBogR*ofs.WVxaR*NHs-axt7WUayWCWVWWjZs.WWR*oKWBbHs.jZWXR*WVayays.ayNHfks.ofayj@ofWVj]',
    picName: 'pic_02',
  },
  {
    year: '2001',
    title: 'Is there a price tag on freedom of speech?',
    content: (
      <>
        <p>
          Heather Armstrong was the first to face the consequences of her online honesty when she was fired for sharing unflattering stories about her coworkers on her blog, dooce.com. The name "dooce" originated from her playful attempts to spell "dude" during chats with friends. Armstrong, obviously with a remarkable writing talent, worked as a design consultant while casually maintaining her blog — until her colleagues discovered how famous she was and how infamously unsightly they were.
        </p>
        <p>
          This incident gave rise to the term "dooced," meaning to be fired for something posted online, highlighting the tricky balance between personal expression and professional life in the digital age.
        </p>
      </>
    ),
    img: pic_03,
    blurhash: '|49GdRr;011Q03$d~VwIIVEgxZsoIpj@%1oeIpR+00XT^+vy^*%f9FNyoz=xIqIp%1%1RjNH%2jFlAwHn3yDD*9a-;WAjE%1NH%0xZ9aR.xaoHxtH?kXx]R5-oS$9G%L-o0gxaxZfhxuV@niX9Rj-;9aM{?aaxV@xuIpIW',
    picName: 'pic_03',
  },
  {
    year: '2003',
    title: 'WordPressism',
    content: (
      <>
        <p>
          In 2003, college student Matt Mullenweg and his friend Mike Little teamed up to create WordPress. What began as a simple project has now become the most widely used content management system (CMS) in the world, powering 43% of all websites on the Internet today.
        </p>
      </>
    ),
    img: pic_04,
    blurhash: '|6A9i?n304tRnhAIM{^i-nAwIV%0%LV@t7e-j]R+AIWAxGofxXRlNHozxD^O-T9wIqxZIqR*%1t50OIp~9%0afxYj?I@E3~ARjENofkBs;M|ofs.%1wvWXI=NH%2wIWCX80hNG^ixFNGxtjrIpWD-SxZI@IpaebbjZxExZ',
    picName: 'pic_04',
  },
  {
    year: '2004',
    title: 'Word of the Year',
    content: (
      <>
        <p>
          In 2004, the word 'blog' was crowned the top word of the year by Merriam-Webster, a prestigious U.S. dictionary publisher. This recognition highlighted the significant impact blogging had made on mainstream culture. It was the ultimate testament to how the blogging phenomenon had truly exploded into the public consciousness.
        </p>
      </>
    ),
    img: pic_05,
    blurhash: '|48gENNe02%2xZVsD%x]Sg^kS4EL%2ofV@s:XSRk0MV?}oogE3f+-;NGRQ0LV@}?NHM|ozX8V?V@=sWBEQs:-US4IVROxt#7t7FLoJxYR+RjWAx]Ips:%LIpIp%2%1o#kDEkxa%0IoS5%1kCbvj]?Ht7IVRjxtRjIpoLs.',
    picName: 'pic_05',
  },
];